import { z } from 'zod';
import { ILegalClient } from '../../ILegalClient';
import { GenericLegalTransactionRelationshipMemberSchema } from '../GenericLegalTransactionRelationshipMemberSchema';
import {
  getEmptyMemberSkeleton,
  ILegalTransactionRelationshipMember,
} from '../ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipRoleEnum } from '../LegalTransactionRelationshipRoleEnum';

const ParticipantMemberDataSchema = z.object({});

export type IMemberParticipantData = z.infer<
  typeof ParticipantMemberDataSchema
>;

export const ParticipantMemberSchema =
  GenericLegalTransactionRelationshipMemberSchema(
    z.literal(LegalTransactionRelationshipRoleEnum.Participant),
    ParticipantMemberDataSchema
  );

export type IMemberParticipant = z.infer<typeof ParticipantMemberSchema>;

export const getEmptyParticipantMemberData = (): IMemberParticipantData => ({});

export function getEmptyParticipantMember(
  legalClient: ILegalClient,
  idRelationship: number,
  data?: IMemberParticipantData
): IMemberParticipant {
  const member: IMemberParticipant = {
    ...getEmptyMemberSkeleton(legalClient, idRelationship),
    idRelationshipRole: LegalTransactionRelationshipRoleEnum.Participant,
    data: data || getEmptyParticipantMemberData(),
  };

  return member;
}

export const isParticipantMember = (
  member: ILegalTransactionRelationshipMember | undefined
): member is IMemberParticipant => {
  return (
    member?.idRelationshipRole ===
    LegalTransactionRelationshipRoleEnum.Participant
  );
};
